import { component as defineComponent } from 'flightjs';

var StyledSelect = function() {
    this.attributes({
        overlayLabel: '[data-styled-select-label]',
        selectTag: '[data-styled-select-select]',
        hoverAttr: 'data-is-hovered'
    });

    this.after('initialize', function() {
        this.on('change', {
            selectTag: this.updateOverlayLabel
        });

        // These are needed for the arrow hover effect which we can't do via css given the select sits over the top
        this.on(this.$node, 'mouseenter', this.addHoverAttr);
        this.on(this.$node, 'mouseleave', this.removeHoverAttr);
    });

    this.addHoverAttr = function(e) {
        this.$node.attr(this.attr.hoverAttr, true);
    };

    this.removeHoverAttr = function(e) {
        this.$node.removeAttr(this.attr.hoverAttr);
    };

    this.updateOverlayLabel = function(e) {
        var selectedText = $(':selected', e.target).text();

        this.select('overlayLabel').text(selectedText);
    };
};

export default defineComponent(StyledSelect);



// WEBPACK FOOTER //
// ./src/web/js/app/ui/styled-select.js